module.exports = __webpack_public_path__ + "img/green_use_of_land_details.77145ddc.svg";